module.exports = __webpack_public_path__ + "static/media/stop-15.81743d4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-15.svg
// module id = 1382
// module chunks = 0